import React from "react";
import Account from "../components/Product/Account";
import Header from "../components/Shared/Header";
import Footer from "../components/Shared/Footer";

function MyAccount() {
  return (
    <>
      <div>
        <Header />
        <Account />
        <Footer />
      </div>
    </>
  );
}

export default MyAccount;
